<template>
  <div class="main">
    <Tabs class="tabs" :tab-list="menuList" title="平台设置" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'setUp',
  data() {
    return {
      menuList: [
        {
          routerName: 'setup/channel',
          text: '支付渠道',
        },
        {
          routerName: 'setup/merchants',
          text: '往来商户',
        },
        {
          routerName: 'setup/rule',
          text: '分账规则',
        },
        {
          routerName: 'setup/switch',
          text: '审核开关',
        },
        {
          routerName: 'setup/develop',
          text: '开发设置',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.main {
  height: 100%;
  .box_column();
}
</style>
